import React from 'react'
import { Table } from 'semantic-ui-react'

export const GroupsTableHeader: React.FC = () => {
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell content="Grupo" />
        <Table.HeaderCell />
      </Table.Row>
    </Table.Header>
  )
}
